(function() {
  const dictTranslationsBullets = {
    en: {
      1: 'Available Stores: ifc mall',
      2: 'Available Store Pickup Period: 26/8 - 19/9',
      3: 'Available Stores: Harbour City',
      4: 'Available Stores: Harbour City, ifc mall',
      5: 'Available Stores: Harbour City',
      6: 'Available Stores: Harbour City, ifc mall and New Town Plaza store',
      7: 'Store Pickup Period(Harbour City store only): until 14/2',
      8: 'Cake Counter Pickup Period: 1/2 - 14/2',
      9: 'Available Counters: Harbour City, Times Square',
      10: '1-Day Ordering Lead Time for Delivery',
      11: '3-Days Ordering Lead Time for Delivery',
      12: '7-Days Ordering Lead Time for Delivery',
      13: '1-Day Ordering Lead Time for Store Pickup',
      14: '3-Days Ordering Lead Time for Store Pickup',
      15: '7-Days Ordering Lead Time for Store Pickup',
      16: 'Available Delivery Period: 9/3 to 31/3',
      17: 'This item can only be ordered with the items in the same category',
      18: 'Only delivery service available for this item',
      19: 'Only store pickup service available for this item',
      20: 'Available Counters: Harbour City, ifc mall, Times Square',
      21: '2-Days Store Pickup Lead Time',
      22: 'Skin-off, Bone-off and Specified Parts Options are not available on EShop',
      23: 'Delivery to remote areas is not available for this item: Tung Chung, Discovery Bay, Sai Kung, Ma Wan, Disneyland, Shek O, Clear Water Bay, Kwu Tung, Tai Lam, Lam Tsuen Tai Po',
      24: 'Available Delivery Period: 22/2',
      25: 'Available Delivery Period: 26/8 - 19/9',
      26: 'Available Store Pickup Period: 26/8 - 12/9',
      27: 'Available Store Pickup Period: 7/9 - 17/9',
      28: 'Available Delivery Period: 6/8 - 21/9',
      29: 'Customer Service will contact for delivery arrangement 3 days in advance',
      30: '2-Days Ordering Lead Time for Delivery',
     
      
    },
    tw: {
      1: '可自取店舖: 國際金融中心分店',
      2: '自取日期: 26/8 - 19/9',
      3: '可自取店舖: 海港城分店',
      4: '可自取店舖: 海港城及國際金融中心分店',
      5: '可自取店舖: 海港城分店',
      6: '可自取店舖: 海港城、國際金融中心及新城市廣場分店',
      7: '自取日期(只限海港城分店): 至14/2',
      8: '自取日期: 1/2 - 14/2',
      9: '可自取店舖: 海港城及時代廣場分店',
      10: '送貨需1天訂單處理時間',
      11: '送貨需3天訂單處理時間',
      12: '送貨需7天訂單處理時間',
      13: '店取需1天訂單處理時間',
      14: '店取需3天訂單處理時間',
      15: '店取需7天訂單處理時間',
      16: '送貨日期: 至14/2',
      17: '此產品只能與相同類別貨品下單',
      18: '此產品只有送貨服務提供',
      19: '此產品只有店取服務提供',
      20: '可自取店舖: 海港城、國際金融中心及時代廣場分店',
      21: '店取需2天訂單處理時間',
      22: '網上商店並不提供去皮、去骨及指定部位的選項',
      23: '偏遠地區送貨服務不適用於此貨品: 東涌,愉景灣,西貢,馬灣,迪士尼樂園,石澳,清水灣,古洞,大欖,大埔林村',
      24: '送貨日期: 22/2',
      25: '送貨日期: 26/8 - 19/9',
      26: '自取日期: 26/8 - 12/9',
      27: '自取日期: 7/9 - 17/9',
      28: '送貨日期: 6/8 - 21/9',
      29: '客戶服務將於3日前聯繫安排送貨',
      30: '送貨需2天訂單處理時間',      
    }
  };

  const dictTranslationsTag = {
    en: {
      1: 'Selected Store for Pickup',
      2: 'Selected Period for Pickup ',
      3: 'Selected Pickup Cake Counter',
      4: '1-Day Delivery',
      5: '3-Days Delivery',
      6: '7-Days Delivery',
      7: '1-Day Pickup',
      8: '3-Days Pickup',
      9: '7-Days Pickup',
      10: 'Selected Period for Delivery',
      11: 'Order with Same Category Item Only',
      12: 'Delivery Available Only',
      13: 'Store Pickup Available Only',
      14: '2-Days Pickup',
      17: '2-Days Delivery',
      
    },
    tw: {
      1: '自取須選擇限定店舖',
      2: '自取須選擇限定日期',
      3: '限定自取蛋糕店舖',
      4: '1天送貨',
      5: '3天送貨',
      6: '7天送貨',
      7: '1天店取',
      8: '3天店取',
      9: '7天店取',
      10: '送貨須選擇限定日期',
      11: '只限與相同類別貨品下單',
      12: '只限送貨',
      13: '只限店取',
      14: '2天店取',
      17: '2天送貨',  
    }
  };




  // NOTE: Only cover Non-general Pickup/Devliery/Shipment option
  /*
  window.tagToTagName = {
    en: {
      'Dashijie ifc Pickup Only': 'Selected Pickup Store',
      'pre-order pickup 2': 'Selected Pickup Period',
      'JPH HC only': 'Selected Pickup Store',
      'JPH HC and IFC only': 'Selected Pickup Store',
      'HC pickup only': 'Selected Pickup Store',
      'HC IFC NTP pickup only': 'Selected Pickup Store',
      'premium sake preorder specific period pickup': 'Selected Pickup Store & Period',
      'Xmas Cake Pickup Only': 'Selected Pickup Period',
      'General Cake Shop Pickup Only without ifc': 'Selected Pickup Cake Counter',
      'General Cake Shop Pickup Only': 'Selected Pickup Cake Counter',
      'premium sake preorder specific period delivery': 'Selected Delivery Period',
      'sake privilege pack specific period delivery': 'Selected Delivery Period',
      'Non Exclusive Brand': 'Order with Same Category Item Only',
      'Delivery Only': 'Delivery Available Only',
      'Store Pickup Only': 'Store Pickup Available Only',
      'cake pickup 6 day leadtime': '2-Days Pickup',
      'pickup 1 day leadtime': '1-Day Pickup',
      'pickup 3 day leadtime': '3-Days Pickup',
      'delivery 1 day leadtime': '1-Day Delivery',
      'delivery 2 day leadtime': '2-Day Delivery',
      'delivery 3 day leadtime': '3-Days Delivery',
      'delivery 7 day leadtime': '7-Days Delivery',
      'pickup 7 day leadtime': '7-Days Pickup',
      'Xmas preorder delivery': 'Selected Delivery Period',
      'Sake Coupon HC ifc NTP and TS Pickup Only': 'Selected Pickup Period',
      'E-gold Preorder Pickyup': 'Selected Pickup Period',
      'E-gold Preorder Delivery': 'Selected Delivery Period',
    },
    tw: {
      'Dashijie ifc Pickup Only': '限定自取店舖',
      'pre-order pickup 2': '限定自取日期',
      'JPH HC only': '限定自取店舖',
      'JPH HC and IFC only': '限定自取店舖',
      'HC pickup only': '限定自取店舖',
      'HC IFC NTP pickup only': '限定自取店舖',
      'premium sake preorder specific period pickup': '限定自取店舖及日期',
      'Xmas Cake Pickup Only': '限定自取日期',
      'General Cake Shop Pickup Only without ifc': '限定自取蛋糕店舖',
      'General Cake Shop Pickup Only': '限定自取蛋糕店舖',
      'premium sake preorder specific period delivery': '限定送貨日期',
      'sake privilege pack specific period delivery': '限定送貨日期',
      'Non Exclusive Brand': '只限與相同類別貨品下單',
      'Delivery Only': '只限送貨',
      'Store Pickup Only': '只限店取',
      'cake pickup 6 day leadtime': '2天店取',
      'pickup 1 day leadtime': '1天店取',
      'pickup 3 day leadtime': '3天店取',
      'delivery 1 day leadtime': '1天送貨',
      'delivery 2 day leadtime': '2天送貨',
      'delivery 3 day leadtime': '3天送貨',
      'delivery 7 day leadtime': '7天送貨',
      'pickup 7 day leadtime': '7天店取',
      'Xmas preorder delivery': '限定送貨日期',
      'Sake Coupon HC ifc NTP and TS Pickup Only': '限定自取日期',
      'E-gold Preorder Pickyup': '限定自取日期',
      'E-gold Preorder Delivery': '限定送貨日期',
    }
  };
  window.tagToTagBullet = {
    en: {
      'Dashijie ifc Pickup Only': 'Available Stores: ifc mall store',
      'pre-order pickup 2': 'Available Store Pickup Period: 26/8 - 19/9',
      'JPH HC only': 'Available Stores: Harbour City store',
      'JPH HC and IFC only': 'Available Stores: Harbour City and ifc mall store',
      'HC pickup only': 'Available Stores: Harbour City store',
      'HC IFC NTP pickup only': 'Available Stores: Harbour City, ifc mall and New Town Plaza store',
      'premium sake preorder specific period pickup': 'Store Pickup Period(Harbour City store only): until 14/2',
      'Xmas Cake Pickup Only': 'Cake Counter Pickup Period: 1/2 - 14/2',
      'General Cake Shop Pickup Only without ifc': 'Available Counters: Harbour City, Times Square',
      'General Cake Shop Pickup Only': 'Available Counters: Harbour City, ifc mall, Times Square',
      'premium sake preorder specific period delivery': 'Available Delivery Period: start from 27/1',
      'sake privilege pack specific period delivery': 'Available Delivery Period: 26/8 - 12/9',
      'Non Exclusive Brand': 'This item can only be ordered with the items in the same category',
      'Delivery Only': 'Only delivery service available for this item',
      'Store Pickup Only': 'Only store pickup service available for this item',
      'cake pickup 6 day leadtime': '2-Days Ordering Lead Time is required for Store Pickup',
      'pickup 1 day leadtime': '1-Day Ordering Lead Time is required for Store Pickup',
      'pickup 3 day leadtime': '3-Days Ordering Lead Time is required for Store Pickup',
      'delivery 1 day leadtime': '1-Day Ordering Lead Time is required for Delivery',
      'delivery 3 day leadtime': '3-Days Ordering Lead Time is required for Delivery',
      'delivery 7 day leadtime': '7-Days Ordering Lead Time is required for Delivery',
      'pickup 7 day leadtime': '7-Days Ordering Lead Time is required for Store Pickup',
      'Fish': 'Skin-off, Bone-off and Specified Parts Options are not available on EShop',
      'Dept-4001-LM': 'Delivery to remote areas is not available for this item: Tung Chung, Discovery Bay, Sai Kung, Ma Wan, Disneyland, Shek O, Clear Water Bay, Kwu Tung, Tai Lam, Lam Tsuen Tai Po',
      'Xmas preorder delivery': 'Available Delivery Period: 26/8 - 19/9',
      'Sake Coupon HC ifc NTP and TS Pickup Only': 'Available Store Pickup Period: 26/8 - 12/9',
      'E-gold Preorder Pickyup': 'Available Store Pickup Period: 7/9 - 17/9',
      'E-gold Preorder Delivery': 'Available Delivery Period: 6/8 - 21/9',
      'Shipping Only': 'Customer Service will contact for delivery arrangement 3 days in advance',
    },
    tw: {
      'Dashijie ifc Pickup Only': '可自取店舖: 國際金融中心分店',
      'pre-order pickup 2': '自取日期: 26/8 - 19/9',
      'JPH HC only': '可自取店舖: 海港城分店',
      'JPH HC and IFC only': '可自取店舖: 海港城及國際金融中心分店',
      'HC pickup only': '可自取店舖: 海港城分店',
      'HC IFC NTP pickup only': '可自取店舖: 海港城、國際金融中心及新城市廣場分店',
      'premium sake preorder specific period pickup': '自取日期(只限海港城分店): 至14/2',
      'Xmas Cake Pickup Only': '自取日期: 1/2 - 14/2',
      'General Cake Shop Pickup Only without ifc': '可自取店舖: 海港城及時代廣場分店',
      'General Cake Shop Pickup Only': '可自取店舖: 海港城、國際金融中心及時代廣場分店',
      'premium sake preorder specific period delivery': '送貨日期: 由 27/1起',
      'sake privilege pack specific period delivery': '送貨日期: 26/8 - 12/9',
      'Non Exclusive Brand': '此產品只能與相同類別貨品下單',
      'Delivery Only': '此產品只有送貨服務提供',
      'Store Pickup Only': '此產品只有店取服務提供',
      'cake pickup 6 day leadtime': '店取需2天訂單處理時間',
      'pickup 1 day leadtime': '店取需1天訂單處理時間',
      'pickup 3 day leadtime': '店取需3天訂單處理時間',
      'delivery 1 day leadtime': '送貨需1天訂單處理時間',
      'delivery 2 day leadtime': '送貨需2天訂單處理時間',
      'delivery 3 day leadtime': '送貨需3天訂單處理時間',
      'delivery 7 day leadtime': '送貨需7天訂單處理時間',
      'pickup 7 day leadtime': '店取需7天訂單處理時間',
      'Fish': '網上商店並不提供去皮、去骨及指定部位的選項',
      'Dept-4001-LM': '偏遠地區送貨服務不適用於此貨品: 東涌,愉景灣,西貢,馬灣,迪士尼樂園,石澳,清水灣,古洞,大欖,大埔林村',
      'Xmas preorder delivery': '送貨日期: 26/8 - 19/9',
      'Sake Coupon HC ifc NTP and TS Pickup Only': '自取日期: 26/8 - 12/9',
      'E-gold Preorder Pickyup': '自取日期: 7/9 - 17/9',
      'E-gold Preorder Delivery': '送貨日期: 6/8 - 21/9',
      'Shipping Only': '客戶服務將於3日前聯繫安排送貨',
    }
  };
  */

  
  window.updateBullets = function() {
    for (var i=1 ;i<=30; ++i) {
      const selector = `.wave-bullet-${i}`;
      let lang = 'en';
      // if (Weglot && Weglot.getCurrentLang() === 'tw') {
      if (Shopify.locale === 'zh-TW') {
        lang = 'tw';
      }
      $(selector).html(dictTranslationsBullets[lang][i]);
    }
  }
  

  function updateTags() {
    for (var i=1 ;i<=17; ++i) {
      const className = `wave-tag-${i}`;
      let lang = 'en';
      // if (Weglot && Weglot.getCurrentLang() === 'tw') {
      if (Shopify.locale === 'zh-TW') {
        lang = 'tw';
      }
      $(`.${className}`).html(dictTranslationsTag[lang][i]);
    }
  }

  const NO_SHOW = -1;
  /*
  function getHTMLPickupOnly(itemCount, countDeliveryOnly, countPickupOnly) {
    if (itemCount == 0 || countPickupOnly == 0 || countDeliveryOnly != 0) return '';
    if (Weglot && Weglot.getCurrentLang() === 'tw') {
      return `因應購物車中一些貨品，只能選擇網購店取。 貨品件數：${itemCount}`;
    } else {
      return `Due to some of items in the cart, only store pickup service is available for this order. No. of items: ${itemCount}`;
    }
  }

  function getHTMLDeliveryOnly(itemCount, countDeliveryOnly, countPickupOnly) {
    if (itemCount == 0 || countDeliveryOnly == 0 || countPickupOnly != 0) return '';
    if (Weglot && Weglot.getCurrentLang() === 'tw') {
      return `因應購物車中一些貨品，只能選擇送貨服務。 貨品件數：${itemCount}`;
    } else {
      return `Due to some of items in the cart, only delivery service is available for this order. No. of items: ${itemCount}`;
    }
  }
  */

  function getHTMLWarnPartialNonExclusiveBrand(countRegularBrand, countNonExclusiveBrand) {
    if (countRegularBrand > 0 && countNonExclusiveBrand > 0) {
      if (Weglot && Weglot.getCurrentLang() === 'tw') {
        return `${countNonExclusiveBrand} 件 <b>${tagToTagName['tw']['Non Exclusive Brand']}</b> 貨品。`;
      } else {
        return `${countNonExclusiveBrand} <b>${tagToTagName['en']['Non Exclusive Brand']}</b> item(s).`
      }
    } else {
      return '';
    }
  }

  function getHTMLWarnPickupDeliveryConflict(countPickupOnly, countDeliveryOnly) {
    if (Weglot && Weglot.getCurrentLang() === 'tw') {
      return `${countPickupOnly} 件 <b>${tagToTagName['tw']['Store Pickup Only']}</b> 和 ${countDeliveryOnly} 件 <b>${tagToTagName['tw']['Delivery Only']}</b> 貨品。`;
    } else {
      return `${countPickupOnly} <b>${tagToTagName['en']['Store Pickup Only']}</b> and ${countDeliveryOnly} <b>${tagToTagName['en']['Delivery Only']}</b> item(s).`;
    }
  }

  function getHTMLPickupOptionOrDeliveryOption(tag, count) {
    // NOTE: Judge hide or not in liquid
    if (Weglot && Weglot.getCurrentLang() === 'tw') {
      const tagName = tagToTagName['tw'][tag];
      if (tagName == NO_SHOW) return '';
      const tagBullet = tagToTagBullet['tw'][tag];
      //return `${count} 件 <b>${tagName}</b> 貨品, 此訂單 ${tagBullet}。`;
      return `<b>${tagName}</b> 貨品, 此訂單 ${tagBullet}。`;
    } else {
      const tagName = tagToTagName['en'][tag];
      if (tagName == NO_SHOW) return '';
      const tagBullet = tagToTagBullet['en'][tag];
      //return `${count} <b>${tagName}</b> item(s). For this order, ${tagBullet}.`;
      return `<b>${tagName}</b>. For this order, ${tagBullet}.`;
    }
  }

  function updateWaveCartReminderOtherCopywritings() {
    console.log('ok');
    if (Weglot && Weglot.getCurrentLang() === 'tw') {
      $('.divCartContainIntroduction').html('購物車包含:');
      $('.divRemindUpdate').html('如有需要可更新以下購物車內容。');
      $('.divMustUpdateCartWarning').html('請按照以下貨品列表更新購物車以完成結帳。');
    } else {
      $('.divCartContainIntroduction').html('Your shopping cart contains:');
      $('.divRemindUpdate').html('You may update the cart below if necessary.');
      $('.divMustUpdateCartWarning').html('Please refer to the below item description and update the shopping cart to complete checkout.');
    }
  }

  /*
  function updateTranslationsForLeadText() {
    if (Weglot && Weglot.getCurrentLang() === 'tw') {
      $('.divShowLeadText').html('因應購物車中一些貨品，訂單需要準備時間。有關貨品數量如下：');
      $('.countPickupLeadDay7').html('7日');
      $('.countPickupLeadDay3').html('3日');
      $('.countPickupLeadDay1').html('1日');
      $('.countDeliveryLeadDay7').html('7日');
      $('.countDeliveryLeadDay3').html('3日');
      $('.countDeliveryLeadDay1').html('1日');
    } else {
      $('.divShowLeadText').html('Due to some of items in the cart, there is ordering lead time for this order. No. of items:');
      $('.countPickupLeadDay7').html('7 days');
      $('.countPickupLeadDay3').html('3 day');
      $('.countPickupLeadDay1').html('1 day');
      $('.countDeliveryLeadDay7').html('7 days');
      $('.countDeliveryLeadDay3').html('3 days');
      $('.countDeliveryLeadDay1').html('1 day');
    }
  }
  */

  window.updateCartShippingTranslations = function() {
    const options = document.querySelector('.cartShippingOptions');
    if (!options) return;
    const {
      countRegularBrand,
      countNonExclusiveBrand,
      countPickupOnly,
      countDeliveryOnly,
      count_Dashijie_ifc_Pickup_Only,
      count_pre_order_pickup_2,
      count_JPH_HC_only,
      count_JPH_HC_and_IFC_only,
      count_HC_pickup_only,
      count_HC_IFC_NTP_pickup_only,
      count_premium_sake_preorder_specific_period_pickup,
      count_Xmas_Cake_Pickup_Only,
      count_General_Cake_Shop_Pickup_Only_without_ifc,
      count_General_Cake_Shop_Pickup_Only,
      count_premium_sake_preorder_specific_period_delivery,
      countPickupLeadDay1,
      countPickupLeadDay3,
      countPickupLeadDay6,
      countPickupLeadDay7,
      countDeliveryLeadDay1,
      countDeliveryLeadDay3,
      countDeliveryLeadDay7,
    } = JSON.parse(options.innerHTML);
    updateWaveCartReminderOtherCopywritings();

    $('.divWarnPartialNonExclusiveBrand').html(getHTMLWarnPartialNonExclusiveBrand(countRegularBrand, countNonExclusiveBrand));
    $('.divWarnPickupDeliveryConflict').html(getHTMLWarnPickupDeliveryConflict(countPickupOnly, countDeliveryOnly));

    $('.divRemindPickupOnly').html(getHTMLPickupOptionOrDeliveryOption('Store Pickup Only', countPickupOnly));
    $('.divRemindDeliveryOnly').html(getHTMLPickupOptionOrDeliveryOption('Delivery Only', countDeliveryOnly));

    $('.divShowPickupOption1').html(getHTMLPickupOptionOrDeliveryOption('Dashijie ifc Pickup Only', count_Dashijie_ifc_Pickup_Only));
    $('.divShowPickupOption2').html(getHTMLPickupOptionOrDeliveryOption('pre-order pickup 2', count_pre_order_pickup_2));
    $('.divShowPickupOption3').html(getHTMLPickupOptionOrDeliveryOption('JPH HC only', count_JPH_HC_only));
    $('.divShowPickupOption4').html(getHTMLPickupOptionOrDeliveryOption('JPH HC and IFC only', count_JPH_HC_and_IFC_only));
    $('.divShowPickupOption5').html(getHTMLPickupOptionOrDeliveryOption('HC pickup only', count_HC_pickup_only));
    $('.divShowPickupOption6').html(getHTMLPickupOptionOrDeliveryOption('HC IFC NTP pickup only', count_HC_IFC_NTP_pickup_only));
    // $('.divShowPickupOption7').html(getHTMLPickupOptionOrDeliveryOption('general citysuper pickup only without LAB', count_general_citysuper_pickup_only_without_LAB));
    // $('.divShowPickupOption8').html(getHTMLPickupOptionOrDeliveryOption('general citysuper pickup only', count_general_citysuper_pickup_only));
    $('.divShowPickupOption9').html(getHTMLPickupOptionOrDeliveryOption('premium sake preorder specific period pickup', count_premium_sake_preorder_specific_period_pickup));
    $('.divShowPickupOption10').html(getHTMLPickupOptionOrDeliveryOption('Xmas Cake Pickup Only', count_Xmas_Cake_Pickup_Only));
    $('.divShowPickupOption11').html(getHTMLPickupOptionOrDeliveryOption('General Cake Shop Pickup Only without ifc', count_General_Cake_Shop_Pickup_Only_without_ifc));
    $('.divShowPickupOption12').html(getHTMLPickupOptionOrDeliveryOption('General Cake Shop Pickup Only', count_General_Cake_Shop_Pickup_Only));
    $('.divShowDeliveryOption1').html(getHTMLPickupOptionOrDeliveryOption('premium sake preorder specific period delivery', count_premium_sake_preorder_specific_period_delivery));

    $('.divShowLeadP1').html(getHTMLPickupOptionOrDeliveryOption('pickup 1 day leadtime', countPickupLeadDay1));
    $('.divShowLeadP3').html(getHTMLPickupOptionOrDeliveryOption('pickup 3 day leadtime', countPickupLeadDay3));
    $('.divShowLeadP6').html(getHTMLPickupOptionOrDeliveryOption('cake pickup 6 day leadtime', countPickupLeadDay6));
    $('.divShowLeadP7').html(getHTMLPickupOptionOrDeliveryOption('pickup 7 day leadtime', countPickupLeadDay7));
    $('.divShowLeadD1').html(getHTMLPickupOptionOrDeliveryOption('delivery 1 day leadtime', countDeliveryLeadDay1));
    $('.divShowLeadD3').html(getHTMLPickupOptionOrDeliveryOption('delivery 3 day leadtime', countDeliveryLeadDay3));
    $('.divShowLeadD7').html(getHTMLPickupOptionOrDeliveryOption('delivery 7 day leadtime', countDeliveryLeadDay7));
  }
  // window.Weglot = window.Weglot || {};
  // if(Shopify.locale == 'zh-TW'){
  //   Weglot.getCurrentLang()  = 'tw';
  // }else{
  //   Weglot.getCurrentLang()  = 'en';
  // }
 window.Weglot = window.Weglot || {};
    Weglot = {
      getCurrentLang : function() {
        if(Shopify.locale == 'zh-TW'){
          return  'tw';
        }else{
          return  'en';
        }
      },
      on: function(){
      return false;
      }
  };
  window.updateBullets();
  updateTags();
  setTimeout(window.updateCartShippingTranslations, 0);

  if (Weglot) {
    Weglot.on("languageChanged", function(newLang, prevLang) {
      window.updateBullets();
      updateTags();
      window.updateCartShippingTranslations();
    });
  }

  const iconInfo = '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M7 0C3.13438 0 0 3.13438 0 7C0 10.8656 3.13438 14 7 14C10.8656 14 14 10.8656 14 7C14 3.13438 10.8656 0 7 0ZM7 12.8125C3.79063 12.8125 1.1875 10.2094 1.1875 7C1.1875 3.79063 3.79063 1.1875 7 1.1875C10.2094 1.1875 12.8125 3.79063 12.8125 7C12.8125 10.2094 10.2094 12.8125 7 12.8125Z" fill="#303030"/><path d="M6.25 4.25C6.25 4.44891 6.32902 4.63968 6.46967 4.78033C6.61032 4.92098 6.80109 5 7 5C7.19891 5 7.38968 4.92098 7.53033 4.78033C7.67098 4.63968 7.75 4.44891 7.75 4.25C7.75 4.05109 7.67098 3.86032 7.53033 3.71967C7.38968 3.57902 7.19891 3.5 7 3.5C6.80109 3.5 6.61032 3.57902 6.46967 3.71967C6.32902 3.86032 6.25 4.05109 6.25 4.25ZM7.375 6H6.625C6.55625 6 6.5 6.05625 6.5 6.125V10.375C6.5 10.4437 6.55625 10.5 6.625 10.5H7.375C7.44375 10.5 7.5 10.4437 7.5 10.375V6.125C7.5 6.05625 7.44375 6 7.375 6Z" fill="#303030"/></svg>';

  window.updateDrawerReminder = function(allTagsForThisProduct) {
    var htmlNew = '';
    const onlyPickup = allTagsForThisProduct.includes('Store Pickup Only');
    const onlyDelivery = allTagsForThisProduct.includes('Delivery Only');
    const isExclusive = allTagsForThisProduct.includes('Non Exclusive Brand');
    const lang = Shopify.locale;
    if(Shopify.locale == 'zh-TW'){
      const lang = 'tw';
    }else{
      const lang = 'en';
    }
    // const lang = Weglot && Weglot.getCurrentLang();
    if (lang === 'tw') {
      if (onlyDelivery & isExclusive) htmlNew = '您剛加入' + tagToTagName['tw']['Delivery Only'] + '的貨品' + tagToTagName['tw']['Non Exclusive Brand'] + '。<br>';
      else if (onlyPickup & isExclusive) htmlNew = '您剛加入' + tagToTagName['tw']['Store Pickup Only'] + '的貨品' + tagToTagName['tw']['Non Exclusive Brand'] + '。<br>';
      else if (onlyDelivery & !isExclusive) htmlNew = '您剛加入' + tagToTagName['tw']['Delivery Only'] + '的貨品。<br>';
      else if (onlyPickup & !isExclusive) htmlNew = '您剛加入' + tagToTagName['tw']['Store Pickup Only'] + '的貨品。<br>';
      else if (isExclusive) htmlNew = '您剛加入 '+ tagToTagName['tw']['Non Exclusive Brand'] + '的貨品。<br>';
    } else {
      if (onlyDelivery & isExclusive) htmlNew = 'A ' + tagToTagName['en']['Delivery Only'] + ' item which can ' + tagToTagName['en']['Non Exclusive Brand'] + ' is just added.<br>';
      else if (onlyPickup & isExclusive) htmlNew = 'A ' + tagToTagName['en']['Store Pickup Only'] + ' item which can ' + tagToTagName['en']['Non Exclusive Brand'] + ' is just added.<br>';
      else if (onlyDelivery & !isExclusive) htmlNew = 'A ' + tagToTagName['en']['Delivery Only'] + ' item is just added.<br>';
      else if (onlyPickup & !isExclusive) htmlNew = 'A ' + tagToTagName['en']['Store Pickup Only'] + ' item is just added.<br>';
      else if (isExclusive) htmlNew = 'An item which can ' + tagToTagName['en']['Non Exclusive Brand'] + ' is just added.<br>';
    }

    if (htmlNew.length > 0) {
      if (lang === 'tw') {
        htmlNew += '如有需要可<b><a href="/cart">更新購物車</a></b>。';
      } else {
        htmlNew += '<b><a href="/cart">Update your cart</a></b> if necessary.';
      }
      $('.wave-fulfill-reminder').html(iconInfo + '<span class="with-icon">' + htmlNew + '</span>');
    }

  };
  window.clearDrawerReminder = function() {
    $('.wave-fulfill-reminder').html('');
  };
})();